<div>
  <button (click)="test()">测试</button>
</div>
